import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12l-6.5 5.5","key":"svg-0"}],["path",{"d":"M12 3v9h9","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}],["path",{"d":"M12 12l5 7.5","key":"svg-3"}]]

const IconChartPie4 = createReactComponent('outline', 'chart-pie-4', 'ChartPie4', __iconNode);

export default IconChartPie4;